import { OnInit, Component, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { ThemeHelper } from '../../../helpers/theme.helpers';
import { MediaService } from '../../../services/media.service';

@Component({
    selector: 'common-editor-control',
    templateUrl: './common.editor.control.html'
})
export class CommonEditorControl implements OnInit, OnDestroy {

    quill;
    customOptions;
    modules;
    FontList;
    FontSizes;
    SelectedColor;
    SelectedBackgroundColor;

    TextValue = '';
    @Input()
    get Text() {
        return this.TextValue;
    }
    set Text(val: string) {
        this.TextValue = val;
        this.TextChange.emit(this.TextValue);
    }
    @Output() TextChange = new EventEmitter<string>();

    PlaceholderValue;
    @Input()
    get Placeholder() {
        return this.PlaceholderValue;
    }
    set Placeholder(val: string) {
        this.PlaceholderValue = val;
        this.InitOptions();
    }


    Subscription;
    ngOnInit(): void {
        this.Subscription = MediaService.CustomFontList.subscribe((fonts) => {
            this.FontList = fonts;
            this.InitOptions();
        });
    }

    ngOnDestroy(): void {
        if (this.Subscription) {
            this.Subscription.unsubscribe();
            this.Subscription = null;
        }
    }

    InitOptions() {
        this.customOptions = [];
        let sizeItem = { 'size': [] };
        if (ThemeHelper.CustomFontSizes) {
            const sizes = [];
            ThemeHelper.CustomFontSizes.forEach((size) => {
                sizes.push(size + 'px');
            });
            this.customOptions.push({
                import: 'attributors/style/size',
                whitelist: sizes
            });
            sizeItem = { 'size': [false, ...sizes] };
            this.FontSizes = sizes;
        }
        let fontItem = { 'font': [] };
        if (this.FontList && this.FontList.length > 0) {
            this.customOptions.push({
                import: 'attributors/class/font',
                whitelist: this.FontList
            });
            fontItem = { 'font': [false, ...this.FontList] };
        }
        this.modules = {
            toolbar: [
                ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                ['blockquote', 'code-block'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
                [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
                [{ 'direction': 'rtl' }],                         // text direction
                [sizeItem],
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                [{ 'color': ['#F00', '#0F0', '#00F', '#000', '#FFF', 'color-picker'] }, { 'background': ['#F00', '#0F0', '#00F', '#000', '#FFF', 'color-picker'] }],          // dropdown with defaults from theme
                [fontItem],
                [{ 'align': [] }],
                ['emoji'],
                ['clean'],                                         // remove formatting button
            ],
            'emoji-shortname': true,
            'emoji-textarea': false,
            'emoji-toolbar': true
        }
    }

    created(event) {
        if (event) {
            this.quill = event;
            var toolbar = this.quill.getModule('toolbar');
            toolbar.addHandler('color', (value) => {
                if (value === 'color-picker') {
                    var picker = document.getElementById('color-picker');
                    if (!picker) {
                        picker = document.createElement('input');
                        picker.id = 'color-picker';
                        picker['type'] = 'color';
                        picker.style.display = 'none';
                        picker['value'] = '#FF0000';
                        document.body.appendChild(picker);
                        let that = this;
                        picker.addEventListener('change', function () {
                            that.quill.format('color', picker['value']);
                        }, false);
                    }
                    picker.click();
                } else {
                    this.quill.format('color', value);
                }
            });
        }
    }

    ColorChanged() {
        if (this.quill) {
            this.quill.format('color', this.SelectedColor, 'user');
        }
    }

    BackgroundChanged() {
        if (this.quill) {
            this.quill.format('background-color', this.SelectedBackgroundColor);
        }
    }

    SelectionChanged(event) {
        if (this.quill && event && event.range) {
            this.SelectedColor = null;
            this.SelectedBackgroundColor = null;
            let format = this.quill.getFormat(event.range.index, event.range.length);
            if (format) {
                if (format.color) {
                    this.SelectedColor = format.color;
                }
                if (format.background) {
                    this.SelectedBackgroundColor = format.background;
                }
            }
        }
    }

    replaceText(text: string) {
        if (this.quill) {
            var range = this.quill.getSelection();
            if (range) {
                this.quill.deleteText(range.index, range.length);
                this.quill.insertText(range.index, text, 'user');                
            }
        }
    }
}